import { ISearchResultComponentFactory } from "../interfaces";

const title: ISearchResultComponentFactory<string> = {

    key: "title",

    createElement: (value, theme) => {
        const element = document.createElement('h4');
        element.innerHTML = value;
        element.className = `font-serif text-serif-xl text-link border-l-10 pl-3 border-light ml-[-20px] group-hover:underline border-theme-${theme}-light`;
        return element;
    },
};

export default title;
